import React, { forwardRef } from 'react'
import {
  Checkbox as BaseCheckbox,
  CheckboxProps as BaseCheckboxProps,
  CheckboxGroup,
} from '@chakra-ui/core'

export { CheckboxGroup }

export interface CheckboxProps extends BaseCheckboxProps {
  onChangeValue?: (value: boolean) => void
}

export const Checkbox = forwardRef(
  ({ onChangeValue, onChange, value, isChecked, ...restProps }: CheckboxProps, ref) => {
    const handleChange = event => {
      onChange && onChange(event)
      onChangeValue && onChangeValue(event.target.checked)
    }

    const _isChecked = isChecked ?? value

    return (
      <BaseCheckbox
        onChange={handleChange}
        ref={ref}
        value={value}
        isChecked={_isChecked}
        {...restProps}
      />
    )
  },
)

export default Checkbox
